import React, { useState } from 'react';
import { Grid, Button, Checkbox, Typography, Card, CardContent, CardHeader, Box, FormGroup, FormControlLabel } from '@mui/material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { Trans, useTranslation } from 'react-i18next';
import { TermsAndPolicies } from '../types/auth';
import { GraphAxios } from 'hooks/useApi';
import Loader from './Loader';

const validationSchema = yup.object().shape({});
const initialValues = {};
type Props = {
    item: TermsAndPolicies;
    api: GraphAxios;
    acceptTerms?: (_id: string) => void;
    openSnackbar: Function;
};
export function TermsView(props: Props) {
    let { item, api, acceptTerms, openSnackbar } = props;
    let [accepted, setAccepted] = useState<boolean>(false);
    let { t } = useTranslation();
    let formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (_, { setSubmitting }) => {
            setSubmitting(true);
            try {
                let response = await api.post('/clients-dashboard/accept-terms/', { id: item._id });
                let { status, msg } = response.data;
                if (status == 'ok') {
                    openSnackbar({
                        open: true,
                        message: t(msg, { ns: ['common', 'translation'] }),
                        variant: 'alert',
                        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                        alert: { color: 'success' },
                        close: false
                    });
                    if (acceptTerms) {
                        acceptTerms(item._id);
                    }
                } else {
                    throw new Error('Unable to accept Terms');
                }
            } catch (error) {
                let msg = (error as Error).message;
                openSnackbar({
                    open: true,
                    message: t(msg, { ns: ['common', 'translation'] }),
                    variant: 'alert',
                    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                    alert: { color: 'error' },
                    close: false
                });
            }
        }
    });
    return (
        <Grid container justifyContent="center">
            <Grid item xs={12} md={10} lg={8}>
                <Card>
                    <CardHeader title={<Trans>{item.name}</Trans>} />
                    <CardContent>
                        {formik.isSubmitting && <Loader />}
                        <form onSubmit={formik.handleSubmit}>
                            <Box dangerouslySetInnerHTML={{ __html: item.template }} />
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox />}
                                    checked={accepted}
                                    onChange={() => {
                                        setAccepted(!accepted);
                                    }}
                                    label={item.tickbox_text}
                                />
                            </FormGroup>
                            {!formik.isSubmitting && (
                                <Box sx={{ textAlign: 'right', mt: 3 }}>
                                    <Button variant="contained" disabled={!accepted} onClick={formik.submitForm}>
                                        <Trans>Accept</Trans>
                                    </Button>
                                </Box>
                            )}
                        </form>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}

export default TermsView;
